.infoBlockWrappre {
  padding: 0 20px;
}

.infoBlock {
  border-radius: 32px;
  border: 1.5px solid #00A66B;
  background: #F3EDDF;
  box-shadow: 3px 5px 0px 0px #00A36F;
  padding: 32px 24px;
  transform: rotate(-7.273deg);
  position: relative;
}

.img {
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 50px;
}

.title {
  color: #231E19;
  text-align: center;
  font-family: ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.4px;
  margin-bottom: 8px;

  span {
    color: #00A36F;
  }
}

.text {
  color:  #7B766F;
  text-align: center;
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.051px;
}

// Dark mode
:global body.dark {
  :local {
    .infoBlock {
      background-color: #2A2928;

      .title {
        color: #fffbf2;
      }

      p {
        color: #8B8984;
      }
    }
  }
}
